module.exports = __webpack_public_path__ + "img/yh.95150cc3.png";